import React from 'react'
import styles from './NotificationBar.module.scss'

export function NotificationBar({ children }) {
  return <div className={styles.bar}>{children}</div>
}

export default NotificationBar
